module.exports = __webpack_public_path__ + "static/media/step4.6d066739.png";